import { EntityModel } from '@/interfaces'
import {
  ALL_FILTER_LEAD_BLOCKS_QUERY,
  CREATE_FILTER_LEAD_BLOCK_MUTATION,
  DELETE_FILTER_LEAD_BLOCK_MUTATION,
  FORCE_DELETE_FILTER_LEAD_BLOCK_MUTATION,
  SINGLE_FILTER_LEAD_BLOCK_QUERY,
  UPDATE_FILTER_LEAD_BLOCK_MUTATION,
} from './graphql'

const cmsFilterLeadBlockModel: EntityModel = {
  name: 'filterLeadBlock',
  namePlural: 'filterLeadBlocks',
  uniqueName: 'cmsFilterLeadBlock',
  uniqueNamePlural: 'cmsFilterLeadBlocks',
  path: 'cms/blocks/filter_lead_block',
  baseUrl: '/cms/blocks/filter_lead_blocks',
  translationPrefix: 'entities:cmsFilterLeadBlock.',
  getDisplayName: (values: any) => {
    return 'Filter Lead Block'
  },
  gql: {
    getAll: ALL_FILTER_LEAD_BLOCKS_QUERY,
    getSingle: SINGLE_FILTER_LEAD_BLOCK_QUERY,
    create: CREATE_FILTER_LEAD_BLOCK_MUTATION,
    update: UPDATE_FILTER_LEAD_BLOCK_MUTATION,
    delete: DELETE_FILTER_LEAD_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_FILTER_LEAD_BLOCK_MUTATION,
  },
  attributes: {
    layout: {
      name: 'layout',
      label: 'entities:cmsFilterLeadBlock.attributes.layout.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'default',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsFilterLeadBlockModel
